
export function fetchingCountries() {
  return {
    type: 'FETCHING_COUNTRIES',
  };
}

export function fetchCountriesSuccess(data) {
  return {
    type: 'FETCH_COUNTRIES_SUCCESS',
    data
  };
}

export function fetchCountriesFailure() {
  return {
    type: 'FETCH_COUNTRIES_FAILED'
  };
}


export function fetchingClub() {
  return {
    type: 'FETCHING_CLUB',
  };
}

export function fetchClubSuccess(data) {
  document.title = "Registratie " + data.Name;

  return {
    type: 'FETCH_CLUB_SUCCESS',
    data
  };
}

export function fetchClubFailure() {
  return {
    type: 'FETCH_CLUB_FAILED'
  };
}


export function fetchingNationalities() {
  return {
    type: 'FETCHING_NATIONALITIES',
  };
}

export function fetchNationalitiesSuccess(data) {
  return {
    type: 'FETCH_NATIONALITIES_SUCCESS',
    data
  };
}

export function fetchNationalitiesFailure() {
  return {
    type: 'FETCH_NATIONALITIES_FAILED'
  };
}

export function submittingForm() {
  return {
    type: 'SUBMITING_FORM',
  };
}

export function submitFormSuccess(data) {
  return {
    type: 'SUBMIT_FORM_SUCCESS',
    data
  };
}

export function submitFormFailure() {
  return {
    type: 'SUBMIT_FORM_FAILED'
  };
}
export function clearSubmitFailure() {
  return {
    type: 'SUBMIT_FORM_CLEAR_FAILED'
  };
}



// WEBPACK FOOTER //
// ./src/registration/RegisterActions.jsx